import React, {PureComponent} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"
import myComments from "@irati/recognition/utils/feed/myComments"
import {GroupCelebration, Poll, Recognition} from "@irati/types"
import {IconTypes} from "@irati/ui/src/Icon"

import Tooltip, {Tip} from "../shared/Tooltip"
import IconWithNumber from "./IconWithNumber"

interface Props {
  id?: string
  item: Poll | Recognition | GroupCelebration
  onClick: () => void
}

class CommentsIcon extends PureComponent<Props> {
  static defaultProps = {
    onClick: () => {},
    id: "commentsIconId"
  }

  render() {
    const {item, onClick} = this.props
    const numComments = item.comments.results.length
    const hasComments = numComments > 0
    const commentIcon = hasComments ? IconTypes.speech : IconTypes.speechPlus
    const hasCommented = myComments(item).length > 0

    return (
      <Tooltip
        placement="bottom"
        tip={
          <Tip id={id("toolTip", this.props)}>
            <FormattedMessage id="recognition.comments.tooltip" />
          </Tip>
        }>
        <span>
          <IconWithNumber
            icon={commentIcon}
            number={numComments}
            active={hasCommented}
            onClick={onClick}
            id={id("iconWithNumber", this.props)}
          />
        </span>
      </Tooltip>
    )
  }
}

export default CommentsIcon
